import Component from '../../lib/component'
import { RootComponent } from '../../main'

export default class ScrollRevealComponent extends Component {
    static selector () {
        return '[data-scroll-reveal]'
    }

    constructor (opts) {
        super(opts)

        this.init = true

        this.render()
        this.listen()
    }

    listen () {
        RootComponent.Scroller.state
            .on('update', () => !this.isRevealed()
                ? this.render()
                : null)

        this.on('resize', () => !this.isRevealed()
            ? this.render()
            : null)
    }

    isVisible () {
        const bounds = this.el.getBoundingClientRect()
        const top = bounds.top - this.getRevealOffsetY()
        const bottom = top + this.el.clientHeight

        const isVisibleTop = top >= 0 && top < window.innerHeight
        const isVisibleBottom = bottom >= 0 && bottom < window.innerHeight
        const isVisibleFull = isVisibleTop && isVisibleBottom

        const isForcePartial = this.props.scrollRevealPartialVisibility === 'true'
        const isShowPartial = isForcePartial
            || this.el.clientHeight > window.innerHeight * 0.5
            || (window.innerHeight > window.innerWidth
                && this.el.clientHeight > window.innerHeight * 0.25)

        return isVisibleFull
            || (this.init
                && (top <= window.innerHeight * 0.95
                    || bottom < window.innerHeight))
            || (top < 0 && bottom > window.innerHeight)
            || (isVisibleTop
                && isShowPartial
                && top <= window.innerHeight * (isForcePartial
                    ? 0.95
                    : 0.9))
            || (isVisibleBottom
                && isShowPartial
                && bottom >= window.innerHeight * (isForcePartial
                    ? 0.05
                    : 0.1))
    }

    isRevealed () {
        return this.props.scrollRevealState === 'revealing'
            || this.props.scrollRevealState === 'revealed'
    }

    getRevealDelay () {
        const revealDelay = parseFloat(this.props.scrollRevealDelay) || 0
        const revealDelayBreakpoint = parseFloat(
            this.props.scrollRevealDelayBreakpoint) || 0

        return revealDelayBreakpoint
                && revealDelayBreakpoint > window.innerWidth
            ? 0
            : revealDelay
    }

    getRevealOffsetY () {
        const offset = Number(this.props.scrollRevealOffsetY || '0')

        return !isNaN(offset)
            ? offset
            : 0
    }

    getAutoplaySrcsetVideos () {
        return Array.from(this.el.querySelectorAll(
            'video[data-srcset][autoplay]'))
    }

    render () {
        const isInit = !!this.init

        if (isInit)
            this.getAutoplaySrcsetVideos()
                .filter(el => !el.getAttribute('data-scroll-reveal-autoplay'))
                .forEach((el) => {
                    el.setAttribute('data-scroll-reveal-autoplay', 'paused')
                    el.pause()
                    el.currentTime = 0
                })

        const isRevealed = this.isRevealed()

        const isVisible = this.isVisible()

        if (isInit)
            this.init = false

        if (isRevealed || !isVisible)
            return

        this.props.scrollRevealState = 'revealing'

        setTimeout(() => {
            this.props.scrollRevealState = 'revealed'

            this.getAutoplaySrcsetVideos()
                .filter(el => el.getAttribute('data-scroll-reveal-autoplay')
                    === 'paused')
                .forEach((el) => {
                    el.setAttribute('data-scroll-reveal-autoplay', 'playing')

                    let isPlay = false

                    if (isInit) {
                        const bounds = el.getBoundingClientRect()
                        const top = bounds.top - this.getRevealOffsetY()
                        const bottom = top + el.clientHeight

                        isPlay = bottom > 0
                    }

                    if (isPlay)
                        try {
                            el.play()
                        }
                        catch (e) {}
                })
        }, this.getRevealDelay())
    }
}
